import { InputTaxList } from 'utils/dataMap';
import { getLabelByValue } from '@lsfe/tools';

const CW = '180px'; // 表单标准宽度

export const COMMON_DIC_CODE = [
    {
        label: '进口',
        value: 1,
    },
    {
        label: '非进口',
        value: 0,
    },
];
export const isMap = {
    0: '否',
    1: '是',
};
export const changWenValue = 5;

export const getFields = (vm) => {
    // 提报信息，销售城市存在加工状态为成品/原料 出现
    const { createInfoModel } = vm;
    // let isFinish = false;
    const isMaterial = createInfoModel ? createInfoModel.skuType === 2 : false;
    return [
        {
            label: '条形码',
            prop: 'skuCodeList',
            slot: 'skuCodeList',
        },
        {
            label: '重量(kg)',
            prop: 'weight',
            slot: 'weight',
            visible() {
                // 原料时不展示
                return !isMaterial;
            },
            description: vm.getBgCategoryLevel1 === 5000000 ? '保持与规格、关联规格，克重数量一致' : '以kg为单位进行填写，且只需填写数字，不需填写单位。如遇包装上既有毛重又有净重信息，需按毛重信息填写',
            descriptionPosition: 'bottom',
        },
        {
            label: '储存条件',
            prop: 'storageTemperatureLevel',
            slot: 'storageTemperatureLevel',
            // template: {
            //     tpl: 'xx-select',
            //     attrs: {
            //         dicCode: 'special:product:newsell_storageTemperatureLevel',
            //         disabled: vm.MixinJudgeRejectedAttrsDisabled('storageTemperatureLevel'),
            //     },
            //     on: {
            //         change: (val) => {
            //             vm.form.storageTemperatureLevel = val;
            //             if (val !== changWenValue) vm.form.storageTemperatureLevelRemark = null;
            //         },
            //     },
            // },
            // detailTemplate: {
            //     tpl: 'xx-enum-text',
            //     attrs: {
            //         dicCode: 'special:product:newsell_storageTemperatureLevel',
            //     },
            // },
            visible() {
                return vm.MixinJudgeFixedAttrNotInDna('storageTemperatureLevel');
            },
        },
        {
            label: '最佳储存温段',
            prop: 'storageTemperatureLevelRemark',
            template: {
                tpl: 'xx-select',
                attrs: {
                    list: [
                        {
                            label: '建议冷藏',
                            value: 1,
                        },
                    ],
                    disabled: vm.MixinJudgeRejectedAttrsDisabled('storageTemperatureLevelRemark'),
                },
            },
            formatter(val) {
                const list = [
                    {
                        label: '建议冷藏',
                        value: 1,
                    },
                ];
                return getLabelByValue(val, list);
            },
            visible() {
                return vm.MixinJudgeFixedAttrNotInDna('storageTemperatureLevel') && vm.form.storageTemperatureLevel === changWenValue;
            },
        },
        {
            label: '商品长宽高(厘米)', // length width height
            slot: 'productSize',
            required: true,
        },
        {
            label: '是否进口',
            prop: 'importFlag',
            slot: 'importFlag',
            // template: {
            //     tpl: 'xx-radio-group',
            //     attrs: {
            //         list: COMMON_DIC_CODE,
            //         disabled: vm.MixinJudgeRejectedAttrsDisabled('importFlag'),
            //     },
            // },
            // formatter(val) {
            //     return isMap[val];
            // },
            visible() {
                return vm.MixinJudgeFixedAttrNotInDna('importFlag');
            },
            descriptionPosition: 'bottom',
            description: '原产地、产地，全部为国外的，选择“是”；原产地(原料产地)为国外，产地为国内、国内分装并且商品实物包装带SC证（食品安全生产许可证)，选择“否”。',
        },
        {
            label: '进项税',
            prop: 'inputTax',
            template: {
                tpl: 'xx-select',
                attrs: {
                    list: InputTaxList,
                    disabled: vm.MixinJudgeRejectedAttrsDisabled('inputTax'),
                },
            },
            style: {
                width: CW,
            },
        },
    ];
};

// 配方单Item结构
export const initRecipeItem = () => ({
    cityIds: [],
    recipeTemplateId: '',
    recipeTemplateName: '', // 配方单名称
    stockFlag: 0, // 库存类型
    overflowLossRate: '', // 溢出损耗率
    recipeIngredientList: [], // 配料信息列表
    existedIds: [], // 原草稿中用户已经设置的 city
});
// 配料表item
export const initRecipeIngredientItem = () => ({
    skuBaseId: '',
    skuName: '',
    specActual: '', // 规格
    quantity: '', // 配料用量
    yieldRate: '', // 出成率
    mainIngredientSkuId: '', // 关联主配料skuid
    mainIngredientFlag: 1, // 是否是主配料
    coreIngredientFlag: 1,
    subLength: 0,
});

export const initBoxProp = () => ({
    boxProps: {
        boxQuantity: '', // 箱规
        boxLength: '',
        boxWidth: '',
        boxHeight: '',
        boxGrossWeight: '', // 箱规毛重
    },
    cityIds: [],
    existedIds: [],
});

export const guaranteePeriodTypeMap = Object.freeze({
    indefinite: 0,
    year: 1,
    month: 2,
    day: 3,
});

export const initBaozhiqi = (data) => ({
    guaranteePeriod: data?.guaranteePeriod || '', // 保质期
    guaranteePeriodType: data?.guaranteePeriodType || data?.guaranteePeriodType === guaranteePeriodTypeMap.indefinite ? data.guaranteePeriodType : guaranteePeriodTypeMap.day, // 类型 默认天
    guaranteePeriodChangeReason: '',
    cityIds: [],
    existedIds: [],
});

export const guaranteePeriodTypeEnum = Object.freeze([
    { label: '无限制', value: 0 },
    { label: '年', value: 1 },
    { label: '月', value: 2 },
    { label: '天', value: 3 },
]);

// 保质期依赖的扩展属性
export const guaranteePeriodAttrIdMap = Object.freeze({
    varietal: 59, // 品种
    seafoodType: 79, // 海鲜状态
});

// dna属性id
export const dnaAttrIdMap = Object.freeze({
    brandId: 10001, // 品牌
    importFlag: 10002, // 是否进口
});

// 扩展属性ID（用于排除不展示的属性）
export const extAttrIdMap = Object.freeze({
    unifiedLocalPurchase: 20304, // 统地采品归属
    FreshOfTheDay: 20355, // 当日鲜
});

export const initChuCangWenDu = () => ({
    storageTemperatureLevelRemark: null,
    storageTemperatureLevel: '',
    cityIds: [],
    existedIds: [],
});


export const initZhaiPeiWenDuan = () => ({
    deliveryTemperatureLevel: '',
    cityIds: [],
    existedIds: [],
});

export const needUpdatePropsMap = {
    cityBoxProps: initBoxProp,
    guaranteePeriod: initBaozhiqi,
    storageTemperatures: initChuCangWenDu,
    deliveryTemperatures: initZhaiPeiWenDuan,
};

export default {};
